export const styles = () => ({
  userContainer: { cursor: 'pointer' },
});
